import React from "react";
import { useParams } from "react-router-dom";

export const HIds = () => {
  const { carroId, filialId } = useParams();
  return { carroId, filialId };
};
